import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { CompanyInternalConfig, HttpResponse } from "@/types";

export function useGetCompanyInternalConfig() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["company-internal-configs", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/company-internal-configs`;
      const res = await guacHttpClient.get<
        CompanyInternalConfig,
        HttpResponse<CompanyInternalConfig>
      >(path);
      return res.data;
    },
    enabled: !!currentCompanyId,
  });
}
